
import AiInput from '../ai-input'
export default {
  components: {
    AiInput
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    last: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    agent(){
      return this.item.agent
    },
    input(){
      return this.item.input
    },
    active() {
      return this.last && !this.completed && !this.input
    },
    answer() {
      return this.item.answer
    },
    description(){
      return this.item.description
    },
    title(){
      return this.item.title
    }
  }
}
